import ReactIs from 'react-is';
export const reactComponentValidator = (value, logger, logLabel) => {
    const valid = ReactIs.isValidElementType(value) && typeof value !== 'string';
    if (!valid) {
        logger(`${logLabel} is not a React Component.`);
    }
    return valid;
};
//# sourceMappingURL=react-component.js.map